module.exports = __webpack_public_path__ + "static/media/ai.d65fe137.png";